import { render, staticRenderFns } from "./TextEditor.vue?vue&type=template&id=73c8c6f0&scoped=true"
import script from "./TextEditor.vue?vue&type=script&lang=ts"
export * from "./TextEditor.vue?vue&type=script&lang=ts"
import style0 from "./TextEditor.vue?vue&type=style&index=0&id=73c8c6f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c8c6f0",
  null
  
)

export default component.exports